import { ModelApiService } from './BaseApiService'

export default class FormsApiService extends ModelApiService {
  constructor() {
    super('forms')
  }

  /**
   * Retrieves form provider info so that the correct UI can be rendered based on the type and URL.
   * @param {string} type - The type of the form.
   * @param {string} formId - The ID of the form.
   * @returns {Promise<any>} The form provider information.
   */
  async getForm(type, formId) {
    return await this.get(`${type}/${formId}`)
  }

  /**
   * Retrieves forms that are not part of registration.
   * @returns {Promise<any>} The list of forms.
   */
  async getForms() {
    return await this.get()
  }

  /**
   * Retrieves the basic info of forms including their status
   * Currently, only pending forms are returned.
   * @returns {Promise<any>} The list of forms requiring action.
   */
  async getFormsStatus() {
    return await this.get('status')
  }
}
